import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "resendButton", "resendText", "countdown", "timer"]
  
  connect() {
    this.resendCooldown = 60 // 60 seconds cooldown
    this.countdownInterval = null
  }

  disconnect() {
    this.clearCountdown()
  }

  async resendCode(event) {
    event.preventDefault()
    
    try {
      this.setResendLoading(true)
      
      const response = await fetch('/mfa/resend_otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })
      
      const data = await response.json()
      
      if (data.success) {
        this.showSuccess('Code sent successfully!')
        this.startResendCooldown()
      } else {
        this.showError(data.error || 'Failed to send code')
      }
    } catch (error) {
      console.error('Failed to resend OTP:', error)
      this.showError('Failed to send code. Please try again.')
    } finally {
      this.setResendLoading(false)
    }
  }

  setResendLoading(loading) {
    this.resendButtonTarget.disabled = loading
    this.resendTextTarget.textContent = loading ? 'Sending...' : 'Didn\'t receive the code? Resend'
  }

  startResendCooldown() {
    let timeLeft = this.resendCooldown
    
    this.resendButtonTarget.disabled = true
    this.countdownTarget.style.display = 'block'
    this.resendTextTarget.textContent = 'Code sent!'
    
    this.countdownInterval = setInterval(() => {
      this.timerTarget.textContent = timeLeft
      timeLeft--
      
      if (timeLeft < 0) {
        this.clearCountdown()
        this.resendButtonTarget.disabled = false
        this.countdownTarget.style.display = 'none'
        this.resendTextTarget.textContent = 'Didn\'t receive the code? Resend'
      }
    }, 1000)
  }

  clearCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
      this.countdownInterval = null
    }
  }

  showSuccess(message) {
    // Create a temporary success message
    const successDiv = document.createElement('div')
    successDiv.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-md shadow-lg z-50'
    successDiv.textContent = message
    document.body.appendChild(successDiv)
    
    setTimeout(() => {
      successDiv.remove()
    }, 3000)
  }

  showError(message) {
    // Create a temporary error message
    const errorDiv = document.createElement('div')
    errorDiv.className = 'fixed top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-md shadow-lg z-50'
    errorDiv.textContent = message
    document.body.appendChild(errorDiv)
    
    setTimeout(() => {
      errorDiv.remove()
    }, 3000)
  }
}